import type { GetProductReviewInsightRequest } from './types';

export const WHAT_PEOPLE_SAY_QUERY_KEYS = {
  default: () => ['whatPeopleSay'] as const,
  getWhatPeopleSay: ({ productId, locale }: GetProductReviewInsightRequest) =>
    [...WHAT_PEOPLE_SAY_QUERY_KEYS.default(), 'getWhatPeopleSay', productId, locale ?? 'en'] as const,
};
